import React, { useEffect, useState } from "react";
import { useReportingTemplateStore } from "../../../config/stores";
import AntdTable from "../../../components/common/AntdTable";
import TableTitle from "../../../components/common/TableTitle";
import { searchTable } from "../../../config/constants";

const AllActionPoints = () => {
  const [filterTable, setFilterTableNull] = useState(null);
  const reportingTemplateStore = useReportingTemplateStore();
  const { allActionPoints, getAllActionPoints, gettingAllActionPoints } =
    reportingTemplateStore;

  useEffect(() => {
    getAllActionPoints();
  }, [getAllActionPoints]);

  const search = (value) => {
    const filterTable = searchTable(allActionPoints.data, value);
    setFilterTableNull(filterTable);
  };

  const columns = [
    {
      title: "Action Point",
      dataIndex: "action_point",
      key: "action_point",
    },
    {
      title: "Project",
      dataIndex: "project",
      key: "project",
      render: (text, record) =>
        record?.activityReportingTemplate?.project?.name,
    },
    {
      title: "Activity",
      dataIndex: "activity",
      key: "activity",
      render: (text, record) =>
        record?.activityReportingTemplate?.activityConceptNote?.activity
          ?.activity,
    },
    {
      title: "Indicator",
      dataIndex: "indicator",
      key: "indicator",
      render: (text, record) =>
        record?.activityReportingTemplate
          ?.activityReportingTemplateIndicators?.[0]?.indicator?.indicator,
    },
    {
      title: "Person Responsible",
      dataIndex: "person_responsible",
      key: "person_responsible",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Timeline",
      dataIndex: "timeline",
      key: "timeline",
    },
    {
      title: "Created By",
      dataIndex: "created_by",
      key: "created_by",
      render: (text, record) => {
        return (
          <span>
            {record?.created_by?.first_name} {record?.created_by?.other_names}
          </span>
        );
      },
    },
  ];

  const refreshTable = () => {
    getAllActionPoints();
  };

  return (
    <div className="container-fluid my-2">
      <h5 className="fw-bold">ACTION POINT TRACKER</h5>
      <AntdTable
        title={() => (
          <TableTitle
            setFilterTableNull={setFilterTableNull}
            openAddModal={null}
            refreshTable={refreshTable}
            search={search}
            exportRecords={null}
          />
        )}
        loading={gettingAllActionPoints}
        columns={columns}
        data={filterTable || allActionPoints}
        rowKey="id"
      />
    </div>
  );
};

export default AllActionPoints;
